import React, { Component } from 'react';
import DarkThemeNav from '../common/dark-theme-nav';

class Panels extends Component {
  state = {
    animatedPanelClass: 'panel--raised'
  }

  handleChangePanelType = (e) => {
    const selectedOption = e.target.value;
    let animatedPanelClass = '';

    switch (selectedOption) {
      case 'raised':
        animatedPanelClass = 'panel--raised';
        break;
      case 'block':
        animatedPanelClass = 'panel--block';
        break;
      case 'colored':
        animatedPanelClass = 'panel--blue-3';
        break;
      case 'outlined':
        animatedPanelClass = 'panel--outline panel--outline--grey-4';
        break;
      case 'callout':
        animatedPanelClass = 'panel--callout panel--callout--blue-2';
        break;
      default:
        animatedPanelClass = 'panel--raised';
        break;
    }

    this.setState({
      animatedPanelClass
    });
  }

  render() {
    const { animatedPanelClass } = this.state;
    return (
      <section>
        <a className="anchor" id="panels"></a>
        <h2>Panels</h2>
        <p>
          Wells, Callouts &#38; Panels have now all been combined into a single component, called Panels. <br/>
          Panels can be used to callout or highlight sections or content, and can be used to apply structure and layout to a page.
        </p>
        <br/>
        <DarkThemeNav anchor="panels" />
        <h4>Block Panel</h4>
        <div className="panel--block">
          <div className="panel__heading">
            <h3 className="flush">Title</h3>
          </div>
          <div className="panel__body">
            Panel content
          </div>
        </div>
        <br/>

        <div className="panel--block panel--block--border">
          <div className="panel__heading">
            <h3 className="flush">Block panel w/ border</h3>
          </div>
          <div className="panel__body">
            Lorem ipsum dolor sit amet
          </div>
        </div>
        <br/>
        <button type="button" className="btn btn--secondary show-code"><i className="fa fa-plus"></i>View source</button><br/><br/>
        <pre className="hide-code"><code className="language-html">{`<div class="panel--block">
      <div class="panel__heading">
        <h3 class="flush">Title</h3>
      </div>
      <div class="panel__body">
        Panel content
      </div>
    </div>

    <div class="panel--block panel--block--border">
      <div class="panel__heading">
        <h3 class="flush">Block panel w/ border</h3>
      </div>
      <div class="panel__body">
        Lorem ipsum dolor sit amet
      </div>
    </div>`}</code></pre>
        <br/>

        <h4>Raised Panel</h4>
        <div className="panel--raised">
          <div className="panel__heading">
            <h3 className="flush">Block raised</h3>
          </div>
          <div className="panel__body">
            Lorem ipsum dolor sit amet
          </div>
        </div>
        <br/>

        <div className="panel--raised panel--raised--border">
          <div className="panel__heading">
            <h3 className="flush">Block raised w/ border</h3>
          </div>
          <div className="panel__body">
            Lorem ipsum dolor sit amet
          </div>
        </div>
        <br/>
        <button type="button" className="btn btn--secondary show-code"><i className="fa fa-plus"></i>View source</button><br/><br/>
        <pre className="hide-code"><code className="language-html">{`<div class="panel--raised">
      <div class="panel__heading">
        <h3 class="flush">Block raised</h3>
      </div>
      <div class="panel__body">
        Lorem ipsum dolor sit amet
      </div>
    </div>

    <div class="panel--raised panel--raised--border">
      <div class="panel__heading">
        <h3 class="flush">Block raised w/ border</h3>
      </div>
      <div class="panel__body">
        Lorem ipsum dolor sit amet
      </div>
    </div>`}</code></pre>
        <br/>

        <h4>Colored Panel</h4>
        <div className="panel--blue-2 ">
          <div className="panel__heading">
            <h3 className="flush">Regal Blue</h3>
          </div>
          <div className="panel__body">
            Lorem ipsum dolor sit amet
          </div>
        </div>
        <br/>

        <div className="panel--blue-3">
          <div className="panel__heading">
            <h3 className="flush">blue-3</h3>
          </div>
          <div className="panel__body">
            Lorem ipsum dolor sit amet
          </div>
        </div>
        <br/>

        <div className="panel--grey-3">
          <div className="panel__heading">
            <h3 className="flush">grey-3</h3>
          </div>
          <div className="panel__body">
            Lorem ipsum dolor sit amet
          </div>
        </div>
        <br/>

        <div className="panel--grey-4">
          <div className="panel__heading">
            <h3 className="flush">Oslo Gray</h3>
          </div>
          <div className="panel__body">
            Lorem ipsum dolor sit amet
          </div>
        </div>
        <br/>
        <button type="button" className="btn btn--secondary show-code"><i className="fa fa-plus"></i>View source</button><br/><br/>
        <pre className="hide-code"><code className="language-html">{`<div class="panel--blue-2 ">
      <div class="panel__heading">
        <h3 class="flush">Regal Blue</h3>
      </div>
      <div class="panel__body">
        Lorem ipsum dolor sit amet
      </div>
    </div>

    <div class="panel--blue-3">
      <div class="panel__heading">
        <h3 class="flush">blue-3</h3>
      </div>
      <div class="panel__body">
        Lorem ipsum dolor sit amet
      </div>
    </div>

    <div class="panel--grey-3">
      <div class="panel__heading">
        <h3 class="flush">grey-3</h3>
      </div>
      <div class="panel__body">
        Lorem ipsum dolor sit amet
      </div>
    </div>

    <div class="panel--grey-4">
      <div class="panel__heading">
        <h3 class="flush">Oslo Gray</h3>
      </div>
      <div class="panel__body">
        Lorem ipsum dolor sit amet
      </div>
    </div>`}</code></pre>
        <br/>

        <h4>Outlined Panel</h4>
        <div className="panel--outline panel--outline--blue-2">
          <div className="panel__heading">
            <h3 className="flush">Regal Blue - Outline Heavy</h3>
          </div>
          <div className="panel__body">
            Lorem ipsum dolor sit amet
          </div>
        </div>
        <br/>

        <div className="panel--outline panel--outline--blue-3">
          <div className="panel__heading">
            <h3 className="flush">blue-3 - Outline Heavy</h3>
          </div>
          <div className="panel__body">
            Lorem ipsum dolor sit amet
          </div>
        </div>
        <br/>

        <div className="panel--outline panel--outline--grey-3">
          <div className="panel__heading">
            <h3 className="flush">grey-3 - Outline Heavy</h3>
          </div>
          <div className="panel__body">
            Lorem ipsum dolor sit amet
          </div>
        </div>
        <br/>

        <div className="panel--outline panel--outline--grey-4">
          <div className="panel__heading">
            <h3 className="flush">Oslo gray - Outline Heavy</h3>
          </div>
          <div className="panel__body">
            Lorem ipsum dolor sit amet
          </div>
        </div>
        <br/>
        <button type="button" className="btn btn--secondary show-code"><i className="fa fa-plus"></i>View source</button><br/><br/>
        <pre className="hide-code"><code className="language-html">{`<div class="panel--outline panel--outline--blue-2">
      <div class="panel__heading">
        <h3 class="flush">Regal Blue - Outline Heavy</h3>
      </div>
      <div class="panel__body">
        Lorem ipsum dolor sit amet
      </div>
    </div>

    <div class="panel--outline panel--outline--blue-3">
      <div class="panel__heading">
        <h3 class="flush">blue-3 - Outline Heavy</h3>
      </div>
      <div class="panel__body">
        Lorem ipsum dolor sit amet
      </div>
    </div>

    <div class="panel--outline panel--outline--grey-3">
      <div class="panel__heading">
        <h3 class="flush">grey-3 - Outline Heavy</h3>
      </div>
      <div class="panel__body">
        Lorem ipsum dolor sit amet
      </div>
    </div>

    <div class="panel--outline panel--outline--grey-4">
      <div class="panel__heading">
        <h3 class="flush">Oslo gray - Outline Heavy</h3>
      </div>
      <div class="panel__body">
        Lorem ipsum dolor sit amet
      </div>
    </div>`}</code></pre>
        <br/>

        <h4>Callout Panel</h4>
        <div className="panel--callout panel--callout--blue-2">
          <div className="panel__heading">
            <h3 className="flush">Regal Blue - Callout</h3>
          </div>
          <div className="panel__body">
            Lorem ipsum dolor sit amet
          </div>
        </div>
        <br/>

        <div className="panel--callout panel--callout--blue-3">
          <div className="panel__heading">
            <h3 className="flush">blue-3 - Callout</h3>
          </div>
          <div className="panel__body">
            Lorem ipsum dolor sit amet
          </div>
        </div>
        <br/>

        <div className="panel--callout panel--callout--grey-3">
          <div className="panel__heading">
            <h3 className="flush">grey-3 - Callout</h3>
          </div>
          <div className="panel__body">
            Lorem ipsum dolor sit amet
          </div>
        </div>
        <br/>

        <div className="panel--callout panel--callout--grey-4">
          <div className="panel__heading">
            <h3 className="flush">Oslo Gray - Callout</h3>
          </div>
          <div className="panel__body">
            Lorem ipsum dolor sit amet
          </div>
        </div>
        <br/>
        <button type="button" className="btn btn--secondary show-code"><i className="fa fa-plus"></i>View source</button><br/><br/>
        <pre className="hide-code"><code className="language-html">{`<div class="panel--callout panel--callout--blue-2">
      <div class="panel__heading">
        <h3 class="flush">Regal Blue - Callout</h3>
      </div>
      <div class="panel__body">
        Lorem ipsum dolor sit amet
      </div>
    </div>

    <div class="panel--callout panel--callout--blue-3">
      <div class="panel__heading">
        <h3 class="flush">blue-3 - Callout</h3>
      </div>
      <div class="panel__body">
        Lorem ipsum dolor sit amet
      </div>
    </div>

    <div class="panel--callout panel--callout--grey-3">
      <div class="panel__heading">
        <h3 class="flush">grey-3 - Callout</h3>
      </div>
      <div class="panel__body">
        Lorem ipsum dolor sit amet
      </div>
    </div>

    <div class="panel--callout panel--callout--grey-4">
      <div class="panel__heading">
        <h3 class="flush">Oslo Gray - Callout</h3>
      </div>
      <div class="panel__body">
        Lorem ipsum dolor sit amet
      </div>
    </div>`}</code></pre>

      <br/>

      <h3>Panel Animations</h3>

      <div className="soft-half">
        <p>
          <label className="display--inline-block push-half--right">Select Panel style: </label>
          <select id="panel-animation-select" style={{ width: 100 + 'px' }} className="display--inline-block" onChange={this.handleChangePanelType}>
            <option value="raised" selected>Raised</option>
            <option value="block">Block</option>
            <option value="colored">Colored</option>
            <option value="outlined">Outlined</option>
            <option value="callout">Callout</option>
          </select>
        </p>
      </div>
      <br />
      <div className="grid">
        <div className="grid__col-xs-12 grid__col-sm-12 grid__col-md-6 grid__col-lg-4">

          <div className={`${animatedPanelClass} panel--move-up`}>
            <div className="panel__heading">
              <h3 className="flush">Move Up Animation</h3>
            </div>
            <div className="panel__body">
              <p>
                Establish and/or maintain Drop Copy Groups used to send carbon copies of iLink execution reports, heartbeats and acknowledgement, and trade bust messages for one or many source sessions.
              </p>
              <i className="fas fa-arrow-right fa-2x" style={{ color: '#006eb6' }}></i>
            </div>
          </div>

        </div>
        <div className="grid__col-xs-12 grid__col-sm-12 grid__col-md-6 grid__col-lg-4">

        <div className={`${animatedPanelClass} panel--sheen`}>
            <div className="panel__heading">
              <h3 className="flush">Sheen Animation</h3>
            </div>
            <div className="panel__body">
              <p>
              Establish and/or maintain Drop Copy Groups used to send carbon copies of iLink execution reports, heartbeats and acknowledgement, and trade bust messages for one or many source sessions.
              </p>
              <i className="fas fa-arrow-right fa-2x" style={{ color: '#006eb6' }}></i>
            </div>
          </div>

        </div>
        <div className="grid__col-xs-12 grid__col-sm-12 grid__col-md-6 grid__col-lg-4">

        <div className={`${animatedPanelClass} panel--scale`}>
            <div className="panel__heading">
              <h3 className="flush">Scale Animation</h3>
            </div>
            <div className="panel__body">
              <p>
              Establish and/or maintain Drop Copy Groups used to send carbon copies of iLink execution reports, heartbeats and acknowledgement, and trade bust messages for one or many source sessions.
              </p>
              <i className="fas fa-arrow-right fa-2x" style={{ color: '#006eb6' }}></i>
            </div>
          </div>

        </div>
      </div>

      <br/>
      <button type="button" className="btn btn--secondary show-code"><i className="fa fa-plus"></i>View source</button><br/><br/>
      <pre className="hide-code"><code className="language-html">{`<div class="grid">

  <div class="grid__col-xs-12 grid__col-sm-12 grid__col-md-6 grid__col-lg-4">
    <div class="${animatedPanelClass} panel--move-up">
      <div class="panel__heading">
        <h3 class="flush">Move Up Animation</h3>
      </div>
      <div class="panel__body">
        <p>
          Establish and/or maintain Drop Copy Groups used to send carbon copies of iLink execution reports, heartbeats and acknowledgement, and trade bust messages for one or many source sessions.
        </p>
        <i class="fas fa-arrow-right fa-2x" style={{ color: '#006eb6' }}></i>
      </div>
    </div>
  </div>

  <div class="grid__col-xs-12 grid__col-sm-12 grid__col-md-6 grid__col-lg-4">
    <div class="${animatedPanelClass} panel--sheen">
      <div class="panel__heading">
        <h3 class="flush">Sheen Animation</h3>
      </div>
      <div class="panel__body">
        <p>
        Establish and/or maintain Drop Copy Groups used to send carbon copies of iLink execution reports, heartbeats and acknowledgement, and trade bust messages for one or many source sessions.
        </p>
        <i class="fas fa-arrow-right fa-2x" style={{ color: '#006eb6' }}></i>
      </div>
    </div>
  </div>

  <div class="grid__col-xs-12 grid__col-sm-12 grid__col-md-6 grid__col-lg-4">
    <div class="${animatedPanelClass} panel--scale">
      <div class="panel__heading">
        <h3 class="flush">Scale Animation</h3>
      </div>
      <div class="panel__body">
        <p>
        Establish and/or maintain Drop Copy Groups used to send carbon copies of iLink execution reports, heartbeats and acknowledgement, and trade bust messages for one or many source sessions.
        </p>
        <i class="fas fa-arrow-right fa-2x" style={{ color: '#006eb6' }}></i>
      </div>
    </div>
  </div>

</div>`}</code></pre>

      <br/>
      <hr/>
      </section>
    );
  }
}

export default Panels



// WEBPACK FOOTER //
// ./styleguide/components/sections/Panels.js